import AWS from 'aws-sdk'
import { CognitoUserPool, CognitoUserAttribute, AuthenticationDetails, CognitoUser, CognitoRefreshToken } from 'amazon-cognito-identity-js'

class Cognito {
  constructor () {
    this.poolData = {
      UserPoolId: null,
      ClientId: null
    }
    this.userPool = null
    this.initializeFlag = false
  }

  initialize (region, userPoolId, clientId) {
    AWS.config.region = region
    this.poolData = {
      UserPoolId: userPoolId,
      ClientId: clientId
    }
    this.userPool = new CognitoUserPool(this.poolData)
    this.initializeFlag = true
    console.log('cognito initialize')
  }

  login (username, password) {
    // if (AWS.config.credentials) {
    //   AWS.config.credentials.clearCachedId()
    // }
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password
    })
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => resolve(result),
        onFailure: err => reject(err),
        // Force Change Password状態で、認証に成功した場合に呼ばれる。
        // この後、ユーザから新しいパスワードを受けとり更新する必要がある。
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          reject({code: 'NewPasswordRequired'})
        }
      })
    })
  }

  logout () {
    // if (AWS.config.credentials) {
    //   AWS.config.credentials.clearCachedId()
    // }
    const currentUser = this.getCurrentUser()
    if (currentUser) {
      currentUser.signOut()
    }
    return Promise.resolve(true)
  }

  getCurrentUser () {
    return this.userPool.getCurrentUser()
  }

  getSession (user) {
    return new Promise((resolve, reject) => {
      user.getSession((err, result) => {
        if (err) {
          reject(err)
        }
        resolve(result, user)
      })
    })
  }

  getUserAttributes () {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        currentUser.getUserAttributes((err, result) => {
          if (err) {
            reject(err)
          }
          const user = {}
          for (let i = 0; i < result.length; i += 1) {
            user[result[i].getName()] = result[i].getValue()
          }
          resolve(user)
        })
      })
    })
  }

  signUp (username, password, attributes) {
    console.log('signup')
    const self = this
    let attributeList = []
    for (const key in attributes) {
      const data = {
        Name: key,
        Value: attributes[key]
      }
      const attr = new CognitoUserAttribute(data)
      attributeList.push(attr)
    }

    return new Promise((resolve, reject) => {
      self.userPool.signUp(username, password, attributeList, null, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  confirmRegistration (username, code) {
    const userData = {
      Username: username,
      Pool: this.userPool
    }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(code, true, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  resendConfirmationCode (username) {
    const userData = {
      Username: username,
      Pool: this.userPool
    }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.resendConfirmationCode((err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  changePassword (oldPassword, newPassword) {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        currentUser.changePassword(oldPassword, newPassword, function (err, result) {
          if (err) {
            reject(err)
          }
          resolve(result)
        })
      })
    })
  }

  forgotPassword (username) {
    const userData = {
      Username: username,
      Pool: this.userPool
    }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess: result => resolve(result),
        onFailure: err => reject(err)
      })
    })
  }

  confirmResetPassword (username, code, newPassword) {
    const userData = {
      Username: username,
      Pool: this.userPool
    }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(code, newPassword, {
        onSuccess: result => resolve(result),
        onFailure: err => reject(err)
      })
    })
  }

  updateUsername (newUsername) {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        const attributeList = []
        const attr = {
          Name: 'preferred_username',
          Value: newUsername
        }
        attributeList.push(new CognitoUserAttribute(attr))
        currentUser.updateAttributes(attributeList, (err, result) => {
          if (err) {
            console.log(err)
            reject(err)
          }
          console.log(result)
          resolve(result)
        })
      })
    })
  }

  updateEmail (newEmail) {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        const attributeList = []
        const attr = {
          Name: 'email',
          Value: newEmail
        }
        attributeList.push(new CognitoUserAttribute(attr))
        currentUser.updateAttributes(attributeList, (err, result) => {
          if (err) {
            console.log(err)
            reject(err)
          }
          console.log(result)
          resolve(result)
        })
      })
    })
  }

  confirmEmail (code) {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        currentUser.verifyAttribute('email', code, {
          onSuccess: result => resolve(result),
          onFailure: err => reject(err)
        })
      })
    })
  }

  resendEmailConfirmationCode () {
    const currentUser = this.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (!currentUser) {
        reject(new Error('not logged in'))
      }
      this.getSession(currentUser).then((result) => {
        currentUser.getAttributeVerificationCode('email', {
          onSuccess: result => resolve(result),
          onFailure: err => reject(err)
        })
      })
    })
  }

  activate (username, password, newPassword) {
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password
    })
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          reject({message: 'This account is already activeated.'})
        },
        onFailure: err => reject(err),
        // Force Change Password状態で、認証に成功した場合に呼ばれる。
        // この後、ユーザから新しいパスワードを受けとり更新する必要がある。
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          cognitoUser.completeNewPasswordChallenge(newPassword, null, {
            onSuccess: result => resolve(result),
            onFailure: err => reject(err)
          })
        }
      })
    })
  }

  refreshSession (username, refreshToken) {
    if (this.initializeFlag && username) {
      const cognitoUser = new CognitoUser({
        Username: username,
        Pool: this.userPool
      })
      return new Promise((resolve, reject) => {
        const cognitoRefreshToken = new CognitoRefreshToken({
          RefreshToken: refreshToken
        })
        cognitoUser.refreshSession(cognitoRefreshToken, (err, result) => {
          if (err) {
            reject(err)
          } else {
            resolve(result)
          }
        })
      })
    }
  }

}

const cognito = new Cognito()

export default cognito



// WEBPACK FOOTER //
// ./src/utils/cognito.js